import React, {Fragment} from 'react';
import FragranceCard from '../FragranceCard/FragranceCard';
import twitterIcon from '../../icons/twitter.svg';
import fbIcon from '../../icons/facebook.svg';
import linkIcon from '../../icons/link.svg';
import emailIcon from '../../icons/email.svg';
import './Results.css';
import {ellipsify, sideScroll} from '../../helpers';

const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const nextResult = () => {
  sideScroll(document.querySelector('.resultsOthers'),'right', 5, document.querySelector('.fragranceCard').clientWidth + window.innerWidth * .03, 10);
}

const prevResult = () => {
  sideScroll(document.querySelector('.resultsOthers'),'left', 5, document.querySelector('.fragranceCard').clientWidth + window.innerWidth * .03, 10);
}

export default (props) => (
  <div className="resultsWrapper">
    { !props.winner.fields ?
      <p>Ooops</p>
    :
      <Fragment>
        <nav className="chevrons">
          <button className="chevron" onClick={() => prevResult() }>
            <img src="/img/left.svg" /> 
          </button>
          <button className="chevron" onClick={() => nextResult() }>
            <img src="/img/right.svg" /> 
          </button>
        </nav>
        <div className="spacingHeader">
          <h2 className="ttu serif tac">We think you'll love&hellip;</h2>
        </div>
        <div className="resultsOthers">
          <div className="cardScroller">
            <FragranceCard
              isWinner
              {...props.winner.fields}
              removeFromBasket={ () => {
                props.removeFromBasket(props.winner);
                props.trackEvent('Fragrance_Experience', `Removed from basket: ${props.winner.fields.name}`, 'Removed from basket', { "product": props.winner.fields.name, "from": 'other' });
              }}
              addToBasket={ () => {
                props.addToBasket(props.winner);
                props.trackEvent('Fragrance_Experience', `Added to basket: ${props.winner.fields.name}`, 'Added to basket', { "product": props.winner.fields.name, "from": 'other' });
              }}
              inBasket={props.basket.filter(item => item.fields.name === props.winner.fields.name).length}
              canAdd={props.basket.length < 2}
            /> 
            { props.otherResults.map( (result, index) => (
              <FragranceCard
                key={index}
                {...result.fields}
                removeFromBasket={ () => {
                  props.removeFromBasket(result);
                  props.trackEvent('Fragrance_Experience', `Removed from basket: ${result.fields.name}`, 'Removed from basket', { "product": result.fields.name, "from": 'other' });
                }}
                addToBasket={ () => {
                  props.addToBasket(result);
                  props.trackEvent('Fragrance_Experience', `Added to basket: ${result.fields.name}`, 'Added to basket', { "product": result.fields.name, "from": 'other' });
                }}
                inBasket={props.basket.filter(item => item.fields.name === result.fields.name).length}
                canAdd={props.basket.length < 2}
              /> 
            ))}
          </div>
        </div>
        <div className="resultsBottom">
          <div className="resultsPageFooter">
            Want to buy in-store? <a href="https://www.penhaligons.com/page/storelocator/" target="_blank" rel="noopener noreferrer">Find your nearest store.</a>
          </div>
          <div className="resultSocial">
            <h2>Share</h2>
            <nav>
              <a href="https://twitter.com/intent/tweet?url=https://newprofiling.penhaligons.com&text=Discover your perfect scent with Penhaligons online fragrance profiling.&via=PenhaligonsLtd" target="_blank" rel="noopener noreferrer" onClick={ () => props.trackEvent('Fragrance_Experience', 'Clicked twitter share') }>
                <img src={twitterIcon} alt="Penhaligon's Twitter" />                      
              </a>
              <a href="https://www.facebook.com/sharer.php?u=https://newprofiling.penhaligons.com" target="_blank" rel="noopener noreferrer" onClick={ () => props.trackEvent('Fragrance_Experience', 'Clicked facebook share') }>
                <img src={fbIcon} alt="Penhaligon's Twitter" />
              </a>
              <a href="mailto:?subject=Discover your perfect scent with Penhaligons online fragrance profiling&body=https://newprofiling.penhaligons.com" onClick={ () => props.trackEvent('Fragrance_Experience', 'Clicked email share') }>
                <img src={emailIcon} alt="Email" />
              </a>
              <button onClick={ () => { copyToClipboard("https://newprofiling.penhaligons.com"); props.setCopied(); props.trackEvent('Fragrance_Experience', 'Copied Link'); } } className="fakeButton">
                <img src={linkIcon} alt="Penhaligon's Twitter" />
                { props.copied ?
                  <span className="tooltip">Link copied</span>
                : null }
              </button>
            </nav>
          </div>
        </div>
      </Fragment>
    }
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Results/Results.js